import React, { useState, useRef, useEffect } from 'react';
import { oneOf, func, string, bool } from 'prop-types';
import { PRODUCT_ADD_ON_IDENTIFIER, DESKTOP, MOBILE } from '@thd-olt-functional/utils';
import { ProductAddOnsPod } from '../../common/product-add-ons-pod';
import { ICONS } from '../../../utils/product-add-on-constants';
import { ProReferralTooltip } from './ProReferral-tooltip';
import { useTippyToggle } from '../../../hooks/useTippyToggle';

const {
  PRO_ASSEMBLY,
  PRO_REFERRAL,
} = PRODUCT_ADD_ON_IDENTIFIER;

const ProReferral = ({
  channel,
  onChange,
  category,
  installType,
  isAssembly
}) => {
  const [checked, setChecked] = useState(false);
  const iconUrl = ICONS.proReferralIconNoText;
  const heading = category === 'Painter' ? 'Request A Painter' : 'Get Referred To A Local Pro';
  const tooltipButtonRef = useTippyToggle(checked);
  const userOptions = [{
    /** Props for checkbox component */
    value: isAssembly ? PRO_ASSEMBLY : PRO_REFERRAL,
    checked,
    label: 'Add Pro Referral'
  }];

  const handleChange = (evt) => {
    if (!isAssembly) { /* pro referral and pro painter */
      LIFE_CYCLE_EVENT_BUS.trigger('pro-referral.change', { isOptedIn: !checked, category });
      onChange({
        checked: evt.target.checked,
        category,
        addOnType: evt.target.value
      });

    } else {
      LIFE_CYCLE_EVENT_BUS.trigger('assembly.change', { isOptedIn: !checked });
      onChange(evt, { data: { } });
    }
    setChecked(!checked);
  };

  return (
    <ProductAddOnsPod
      channel={channel}
      heading={heading}
      icon={iconUrl}
      iconHeight={24}
      onChange={handleChange}
      tooltip={<ProReferralTooltip ref={tooltipButtonRef} channel={channel} />}
      userOptions={userOptions}
    />
  );
};

ProReferral.displayName = 'ProductAddOns-ProReferral';

ProReferral.propTypes = {
  /** What view to render ['desktop' || 'mobile']  */
  channel: oneOf([DESKTOP, MOBILE]),
  /** Callback exec when user selects pro-referral option  */
  onChange: func.isRequired,
  /** Category .ie. PRInstall, Painter for paint   */
  category: string,
  /** type Painter for paint or null for default pro referral */
  installType: string,
  /** proAssembly */
  isAssembly: bool,
};

ProReferral.defaultProps = {
  channel: DESKTOP,
  installType: '',
  category: '',
  isAssembly: false
};

export { ProReferral };